import Actions from '../../odata/actions';

const actions = new Actions('industry', 'industries');

export default actions;
